import { Injectable, inject } from '@angular/core'
import { ApiClient, ApiClientFactory, serializeHttpParams } from '@ftr/api-shared'
import { DigitalJusticeFeature } from '@ftr/contracts/api/digital-justice'
import { Feature, ToggleFeatureBody } from '@ftr/contracts/api/feature'
import { CourtSystemIdQuery } from '@ftr/contracts/api/shared'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, createAndAssign, mapData } from '@ftr/foundation'
import { classToPlain } from '@ftr/serialization'

@Injectable()
export class TrmRepositoriesAndUploadsFeatureService {
  private readonly apiClient: ApiClient

  constructor() {
    const apiClientFactory = inject(ApiClientFactory)
    this.apiClient = apiClientFactory.build('/trm-repositories-and-uploads-feature')
  }

  isEnabled(courtSystemId: Uuid): ApiResult<boolean> {
    return this.getForCourtSystem(courtSystemId).pipe(mapData(d => d.isEnabled))
  }

  getForCourtSystem(courtSystemId: Uuid): ApiResult<Feature> {
    return this.apiClient.get<DigitalJusticeFeature>({
      path: '/getForCourtSystem',
      params: serializeHttpParams(createAndAssign(CourtSystemIdQuery, { courtSystemId })),
    })
  }

  updateFeature(featureId: Uuid, body: ToggleFeatureBody): ApiResult<Feature> {
    return this.apiClient.patch({
      path: `/${featureId}`,
      body: classToPlain(body),
    })
  }
}
